import type { SVGProps } from 'react';

export const AddLayoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M19.0004 2.66699H5.00041C2.97774 2.66699 1.33374 4.31099 1.33374 6.33366V17.667C1.33374 19.6897 2.97774 21.3337 5.00041 21.3337H13.8369C13.5179 20.857 13.3318 20.2838 13.3318 19.6673C13.3318 19.5545 13.338 19.4432 13.3501 19.3337H9.33374V4.66699H19.0004C19.9191 4.66699 20.6671 5.41499 20.6671 6.33366V13.5055C21.8311 13.9179 22.6651 15.0288 22.6651 16.334V16.6673H22.6671V6.33366C22.6671 4.31099 21.0231 2.66699 19.0004 2.66699ZM20.6651 18.6673H22.9984C23.5504 18.6673 23.9984 19.1153 23.9984 19.6673C23.9984 20.2193 23.5504 20.6673 22.9984 20.6673H20.6651V23.0006C20.6651 23.5526 20.2171 24.0006 19.6651 24.0006C19.1131 24.0006 18.6651 23.5526 18.6651 23.0006V20.6673H16.3318C15.7798 20.6673 15.3318 20.2193 15.3318 19.6673C15.3318 19.1153 15.7798 18.6673 16.3318 18.6673H18.6651V16.334C18.6651 15.782 19.1131 15.334 19.6651 15.334C20.2171 15.334 20.6651 15.782 20.6651 16.334V18.6673Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
